import Image from '@base/Image';
import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';

const Container = styled.div`
  display: flex;
  width: 100%;
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
  }
  & > :not(:last-child) {
    margin-right: ${Spacings.SPACING_6B};
    ${mediaQuery.uptoMobile} {
      margin-right: ${Spacings.SPACING_0B};
      margin-bottom: ${Spacings.SPACING_3B};
    }
  }
`;

const BenefitContainer = styled.div`
  display: flex;
  align-items: center;
`;

const BenefitInfo = styled.div`
  margin-left: ${Spacings.SPACING_2B};
  color: var(--color-text-primary);
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.SMALL};
  line-height: ${Fonts.LARGE};
`;

const BenefitsList = ({ items = [] }) => {
  if (!items?.length) return null;
  return (
    <Container>
      {items?.map((item) => {
        const { icon, text } = item;
        return (
          <BenefitContainer key={text}>
            <Image src={icon} alt="icon" width={20} height={20} />
            <BenefitInfo>{text}</BenefitInfo>
          </BenefitContainer>
        );
      })}
    </Container>
  );
};

export default BenefitsList;
